import { Accounts } from '@or-sdk/accounts';

import { useAuthStore } from '@/stores/auth/auth';

import config from '../config';

export default new Accounts({
  sdkUrl: `${config.SDK_API_URL}`,
  token: () => useAuthStore().reactiveToken as string,
});
